import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue"
import _imports_0 from '@/assets/themeThree/male_10.jpg'
import _imports_1 from '@/assets/themeThree/envelop.png'
import _imports_2 from '@/assets/themeThree/copy-icon.png'
import _imports_3 from '@/assets/themeThree/level_one.png'
import _imports_4 from '@/assets/themeThree/refresh.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "head_card" }
const _hoisted_3 = { class: "notif" }
const _hoisted_4 = {
  key: 0,
  class: "unreadCount"
}
const _hoisted_5 = { style: {"margin-top":"-10px"} }
const _hoisted_6 = { class: "contact" }
const _hoisted_7 = { class: "id" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { style: {"font-size":"18px"} }

import PrimaryButton from '../../components/common/primaryButton.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useUserStore } from '@/stores/user';
import { formatCurrency } from '@/utils/commonFunction';
import CarteiraView from '@/view/carteiraView/carteiraView.vue';
import { buttonClick, clickOnCard, copyID } from '@/view/profile/supportScript';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'headCard',
  setup(__props) {

const router = useRouter()
const statusRef = ref();
const userStore = useUserStore()
const name = computed(() => userStore.nickname)
const balance = computed(() => userStore.balance)
const id = computed(() => userStore.id)
const unreadMsgCount = computed(() => userStore.unreadCount)
const isPopping = ref(false)
const walletPopupRef = ref()
const loadingRef = ref()

const onClickCard = () => clickOnCard(router, isPopping, '/sd-message')
const onCopyID = (id: any) => copyID(statusRef, id)
const onButtonClick = (type: string) => {
    if (type === 'withdraw') {
        router.push({ path: '/sd-withdraw' });
    } else if (type === 'topup') {
        router.push({ path: '/sd-topup' });
        localStorage.setItem('showDepositBackIcon', '1')
    }
}

async function refreshDetails() {
    try {
        loadingRef.value.open()
        await userStore.getInfo()
    } catch (e) {
        console.log(e);
    } finally {
        loadingRef.value.close()
    }
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "7",
            class: "avatar"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "17",
            class: "detailsContainer"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "",
                  onClick: onClickCard
                }),
                (unreadMsgCount.value > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(unreadMsgCount.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.$t('profile.id')) + " : " + _toDisplayString(id.value) + " ", 1),
                  _createElementVNode("img", {
                    src: _imports_2,
                    alt: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (onCopyID(id.value)))
                  }),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "level" }, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      alt: ""
                    })
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('profile.conta')) + " : " + _toDisplayString(name.value), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(formatCurrency)(balance.value)) + " R$ ", 1),
                  _createElementVNode("img", {
                    onClick: refreshDetails,
                    src: _imports_4,
                    alt: ""
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "12",
            class: "withdraw_btn"
          }, {
            default: _withCtx(() => [
              _createVNode(PrimaryButton, {
                text: _ctx.$t('common.sake'),
                textColor: "#fff",
                bgColor: "#2a324e",
                icon: require('@/assets/themeThree/withdraw.png'),
                onOnClick: _cache[1] || (_cache[1] = ($event: any) => (onButtonClick('withdraw')))
              }, null, 8, ["text", "icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "12",
            class: "deposit_btn"
          }, {
            default: _withCtx(() => [
              _createVNode(PrimaryButton, {
                text: _ctx.$t('common.deposite'),
                textColor: "#fff",
                bgColor: "#17af5f",
                icon: require('@/assets/themeThree/deposit.png'),
                onOnClick: _cache[2] || (_cache[2] = ($event: any) => (onButtonClick('topup')))
              }, null, 8, ["text", "icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      content: _ctx.$t('common.copied'),
      isShowSuccess: true
    }, null, 8, ["content"]),
    _createVNode(CarteiraView, {
      ref_key: "walletPopupRef",
      ref: walletPopupRef
    }, null, 512),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ]))
}
}

})